import { render, staticRenderFns } from "./Logistic.vue?vue&type=template&id=cd9fb2c0&scoped=true&"
import script from "./Logistic.vue?vue&type=script&lang=js&"
export * from "./Logistic.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=cd9fb2c0&scoped=true&lang=css&"
import style1 from "./Logistic.vue?vue&type=style&index=1&id=cd9fb2c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9fb2c0",
  null
  
)

export default component.exports